export const capeData = [
  {
    id: "1",
    name: "Black Butterfly",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/1.gltf",
    preview: "/cosmetic/preview/cape/1.webp",
    obtain: ["Enchanted Money Crate"],
  },
  {
    id: "2",
    name: "Dark Cross",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/2.gltf",
    preview: "/cosmetic/preview/cape/2.webp",
    obtain: ["Enchanted Money Crate"],
  },
  {
    id: "3",
    name: "Day Dream",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/3.gltf",
    preview: "/cosmetic/preview/cape/3.webp",
    obtain: ["Enchanted Money Crate"],
  },
  {
    id: "4",
    name: "Fake Wing",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/4.gltf",
    preview: "/cosmetic/preview/cape/4.webp",
    obtain: ["Enchanted Money Crate"],
  },
  {
    id: "5",
    name: "Black L",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/5.gltf",
    preview: "/cosmetic/preview/cape/5.webp",
    obtain: ["Enchanted Money Crate"],
  },
  {
    id: "6",
    name: "Orangest",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/6.gltf",
    preview: "/cosmetic/preview/cape/6.webp",
    obtain: ["Survival Games Level 50 Reward"],
  },
  {
    id: "7",
    name: "Chimera",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/7.gltf",
    preview: "/cosmetic/preview/cape/7.webp",
    obtain: ["Unreleased"],
  },
  {
    id: "8",
    name: "Darkblue L",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/8.gltf",
    preview: "/cosmetic/preview/cape/8.webp",
    obtain: ["Unreleased"],
  },
  {
    id: "9",
    name: "Double07",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/9.gltf",
    preview: "/cosmetic/preview/cape/9.webp",
    obtain: ["Unreleased"],
  },
  {
    id: "10",
    name: "White Slash",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/10.gltf",
    preview: "/cosmetic/preview/cape/10.webp",
    obtain: ["Exotic Madness Crate"],
  },
  {
    id: "11",
    name: "Golden Heart",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/11.gltf",
    preview: "/cosmetic/preview/cape/11.webp",
    obtain: ["Exotic Madness Crate"],
  },
  {
    id: "12",
    name: "Katana Symbol",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/12.gltf",
    preview: "/cosmetic/preview/cape/12.webp",
    obtain: ["Unreleased"],
  },
  {
    id: "13",
    name: "Herz",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/13.gltf",
    preview: "/cosmetic/preview/cape/13.webp",
    obtain: ["Unreleased"],
  },
  {
    id: "14",
    name: "BlackHeart",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/14.gltf",
    preview: "/cosmetic/preview/cape/14.webp",
    obtain: ["Unreleased"],
  },
  {
    id: "15",
    name: "Brown Chicken",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/15.gltf",
    preview: "/cosmetic/preview/cape/15.webp",
    obtain: ["Enchanted Money Crate"],
  },
  {
    id: "16",
    name: "Crowned Clown",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/16.gltf",
    preview: "/cosmetic/preview/cape/16.webp",
    obtain: ["Enchanted Money Crate"],
  },
  {
    id: "17",
    name: "Uchiha",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/17.gltf",
    preview: "/cosmetic/preview/cape/17.webp",
    obtain: ["Unreleased"],
  },
  {
    id: "18",
    name: "Sunset",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/18.gltf",
    preview: "/cosmetic/preview/cape/18.webp",
    obtain: ["Exotic Madness Crate"],
  },
  {
    id: "19",
    name: "TikTok",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/19.gltf",
    preview: "/cosmetic/preview/cape/19.webp",
    obtain: [
      "Vip Rank",
      "Booster Rank",
      "Media Rank",
      "Famous Rank",
      "Mvp Rank",
      "Mvp+ Rank",
    ],
  },
  {
    id: "20",
    name: "Pepe",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/20.gltf",
    preview: "/cosmetic/preview/cape/20.webp",
    obtain: ["Exotic Madness Crate"],
  },
  {
    id: "21",
    name: "Polar Bear",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/21.gltf",
    preview: "/cosmetic/preview/cape/21.webp",
    obtain: ["Enchanted Money Crate"],
  },
  {
    id: "22",
    name: "Nike White",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/22.gltf",
    preview: "/cosmetic/preview/cape/22.webp",
    obtain: ["Staff Rank"],
  },
  {
    id: "23",
    name: "No Man Sky",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/23.gltf",
    preview: "/cosmetic/preview/cape/23.webp",
    obtain: ["Enchanted Money Crate", "Guarantee Epic Crate"],
  },
  {
    id: "24",
    name: "Mashmello",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/24.gltf",
    preview: "/cosmetic/preview/cape/24.webp",
    obtain: ["Unreleased"],
  },
  {
    id: "25",
    name: "Hacker",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/25.gltf",
    preview: "/cosmetic/preview/cape/25.webp",
    obtain: ["SG Level 100 Reward"],
  },
  {
    id: "26",
    name: "The Starry Night",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/26.gltf",
    preview: "/cosmetic/preview/cape/26.webp",
    obtain: ["Enchanted Money Crate", "Guarantee Epic Crate"],
  },
  {
    id: "27",
    name: "White Wolf",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/27.gltf",
    preview: "/cosmetic/preview/cape/27.webp",
    obtain: ["Mvp Rank", "Mvp+ Rank"],
  },
  {
    id: "28",
    name: "The Rich",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/28.gltf",
    preview: "/cosmetic/preview/cape/28.webp",
    obtain: ["Enchanted Money Crate", "Guarantee Legendary Crate"],
  },
  {
    id: "29",
    name: "Bruhhh",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/29.gltf",
    preview: "/cosmetic/preview/cape/29.webp",
    obtain: ["Unreleased"],
  },
  {
    id: "30",
    name: "BED",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/30.gltf",
    preview: "/cosmetic/preview/cape/30.webp",
    obtain: ["Exotic Madness Crate"],
  },
  {
    id: "31",
    name: "XOOP TWERKING",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/31.gltf",
    preview: "/cosmetic/preview/cape/31.webp",
    obtain: ["Season 1 Leaderboard (#1) Rewards and Limited Giveaway"],
  },
  {
    id: "32",
    name: "1 MILL",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/32.gltf",
    preview: "/cosmetic/preview/cape/32.webp",
    obtain: ["Exotic Madness Crate"],
  },
  {
    id: "33",
    name: "Three Blade",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/33.gltf",
    preview: "/cosmetic/preview/cape/33.webp",
    obtain: ["Exotic Madness Crate"],
  },
  {
    id: "34",
    name: "Adam Warlock",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/34.gltf",
    preview: "/cosmetic/preview/cape/34.webp",
    obtain: ["Season 5 Login Reward"],
  },
  {
    id: "35",
    name: "Purple Assasin",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/35.gltf",
    preview: "/cosmetic/preview/cape/35.webp",
    obtain: ["Season 1 Zeqa Pass"],
  },
  {
    id: "36",
    name: "Bear",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/36.gltf",
    preview: "/cosmetic/preview/cape/36.webp",
    obtain: ["Exotic Madness Crate"],
  },
  {
    id: "37",
    name: "Black Hole",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/37.gltf",
    preview: "/cosmetic/preview/cape/37.webp",
    obtain: ["Season 1 Zeqa Pass"],
  },
  {
    id: "38",
    name: "Pastel MLG",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/38.gltf",
    preview: "/cosmetic/preview/cape/38.webp",
    obtain: ["Unreleased"],
  },
  {
    id: "39",
    name: "CawPe",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/39.gltf",
    preview: "/cosmetic/preview/cape/39.webp",
    obtain: ["Exotic Madness Crate"],
  },
  {
    id: "40",
    name: "Shiba Inu",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/40.gltf",
    preview: "/cosmetic/preview/cape/40.webp",
    obtain: ["Unreleased"],
  },
  {
    id: "41",
    name: "White Chicken",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/41.gltf",
    preview: "/cosmetic/preview/cape/41.webp",
    obtain: ["Bot Duels"],
  },
  {
    id: "42",
    name: "Duck",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/42.gltf",
    preview: "/cosmetic/preview/cape/42.webp",
    obtain: ["Unreleased"],
  },
  {
    id: "43",
    name: "Fantastic Blue",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/43.gltf",
    preview: "/cosmetic/preview/cape/43.webp",
    obtain: ["Bot Duels"],
  },
  {
    id: "44",
    name: "Cute Cowboy",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/44.gltf",
    preview: "/cosmetic/preview/cape/44.webp",
    obtain: ["Season 1 Zeqa Pass"],
  },
  {
    id: "45",
    name: "Pastel Cute Face",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/45.gltf",
    preview: "/cosmetic/preview/cape/45.webp",
    obtain: ["Bot Duels"],
  },
  {
    id: "46",
    name: "Yellow Demonic Smile",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/46.gltf",
    preview: "/cosmetic/preview/cape/46.webp",
    obtain: ["Unreleased"],
  },
  {
    id: "47",
    name: "Black Devil Smile",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/47.gltf",
    preview: "/cosmetic/preview/cape/47.webp",
    obtain: ["Bot Duels"],
  },
  {
    id: "48",
    name: "Christmas 2021 - Snowman",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/48.gltf",
    preview: "/cosmetic/preview/cape/48.webp",
    obtain: ["2021 Christmas Event Crate"],
  },
  {
    id: "49",
    name: "Christmas 2021 - Pine",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/49.gltf",
    preview: "/cosmetic/preview/cape/49.webp",
    obtain: ["2021 Christmas Event Crate"],
  },
  {
    id: "50",
    name: "Christmas 2021 - Candy",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/50.gltf",
    preview: "/cosmetic/preview/cape/50.webp",
    obtain: ["2021 Christmas Event Crate"],
  },
  {
    id: "51",
    name: "Christmas 2021 - Reindeer",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/51.gltf",
    preview: "/cosmetic/preview/cape/51.webp",
    obtain: ["2021 Christmas Event Crate"],
  },
  {
    id: "52",
    name: "Ninja",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/52.gltf",
    preview: "/cosmetic/preview/cape/52.webp",
    obtain: ["Sun Land Crate", "Guarantee Epic Crate"],
  },
  {
    id: "53",
    name: "Rising Sun",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/53.gltf",
    preview: "/cosmetic/preview/cape/53.webp",
    obtain: ["Sun Land Crate"],
  },
  {
    id: "54",
    name: "Sakura Tree",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/54.gltf",
    preview: "/cosmetic/preview/cape/54.webp",
    obtain: ["Sun Land Crate"],
  },
  {
    id: "55",
    name: "Cherry Blossom",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/55.gltf",
    preview: "/cosmetic/preview/cape/55.webp",
    obtain: ["Sun Land Crate"],
  },
  {
    id: "56",
    name: "The Great Wave",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/56.gltf",
    preview: "/cosmetic/preview/cape/56.webp",
    obtain: ["Sun Land Crate", "Guarantee Legendary Crate"],
  },
  {
    id: "57",
    name: "Twitch",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/57.gltf",
    preview: "/cosmetic/preview/cape/57.webp",
    obtain: ["Media Rank"],
  },
  {
    id: "58",
    name: "Youtube",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/58.gltf",
    preview: "/cosmetic/preview/cape/58.webp",
    obtain: ["Media Rank"],
  },
  {
    id: "59",
    name: "Zeqa Staff",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/59.gltf",
    preview: "/cosmetic/preview/cape/59.webp",
    obtain: ["Staff Rank"],
  },
  {
    id: "60",
    name: "Samurai Helmet",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/60.gltf",
    preview: "/cosmetic/preview/cape/60.webp",
    obtain: ["Sun Land Crate"],
  },
  {
    id: "61",
    name: "Rick Roll",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/61.gltf",
    preview: "/cosmetic/preview/cape/61.webp",
    obtain: ["Discord Invitation Event"],
  },
  {
    id: "62",
    name: "Valentine 2022 - Bed Heart",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/62.gltf",
    preview: "/cosmetic/preview/cape/62.webp",
    obtain: ["2022 Valentine Event Crate"],
  },
  {
    id: "63",
    name: "Valentine 2022 - Rose",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/63.gltf",
    preview: "/cosmetic/preview/cape/63.webp",
    obtain: ["2022 Valentine Event Crate"],
  },
  {
    id: "64",
    name: "Zeqentine 2022",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/64.gltf",
    preview: "/cosmetic/preview/cape/64.webp",
    obtain: ["2022 Valentine Event Voting"],
  },
  {
    id: "65",
    name: "Valentine 2022 - Black Heart",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/65.gltf",
    preview: "/cosmetic/preview/cape/65.webp",
    obtain: ["2022 Valentine Event Crate"],
  },
  {
    id: "66",
    name: "Valentine 2022 - Teddy",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/66.gltf",
    preview: "/cosmetic/preview/cape/66.webp",
    obtain: ["2022 Valentine Event Crate"],
  },
  {
    id: "67",
    name: "Valentine 2022 - White Heart",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/67.gltf",
    preview: "/cosmetic/preview/cape/67.webp",
    obtain: ["2022 Valentine Event Crate"],
  },
  {
    id: "68",
    name: "Baby Yoda",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/68.gltf",
    preview: "/cosmetic/preview/cape/68.webp",
    obtain: ["Meme Time Crate"],
  },
  {
    id: "69",
    name: "Confused Winnie",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/69.gltf",
    preview: "/cosmetic/preview/cape/69.webp",
    obtain: ["Meme Time Crate"],
  },
  {
    id: "70",
    name: "Cukiee",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/70.gltf",
    preview: "/cosmetic/preview/cape/70.webp",
    obtain: ["Meme Time Crate", "Guarantee Epic Crate"],
  },
  {
    id: "71",
    name: "Emlu",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/71.gltf",
    preview: "/cosmetic/preview/cape/71.webp",
    obtain: ["Meme Time Crate", "Guarantee Epic Crate"],
  },
  {
    id: "72",
    name: "Minion",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/72.gltf",
    preview: "/cosmetic/preview/cape/72.webp",
    obtain: ["Meme Time Crate", "Guarantee Legendary Crate"],
  },
  {
    id: "73",
    name: "Tea Time Kermit",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/73.gltf",
    preview: "/cosmetic/preview/cape/73.webp",
    obtain: ["Meme Time Crate", "Guarantee Legendary Crate"],
  },
  {
    id: "74",
    name: "R3 X ZEQA",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/74.gltf",
    preview: "/cosmetic/preview/cape/74.webp",
    obtain: ["R3 Tournament Event"],
  },
  {
    id: "75",
    name: "Missing Texture",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/75.gltf",
    preview: "/cosmetic/preview/cape/75.webp",
    obtain: ["Computer Geek Crate"],
  },
  {
    id: "76",
    name: "Code",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/76.gltf",
    preview: "/cosmetic/preview/cape/76.webp",
    obtain: ["Computer Geek Crate"],
  },
  {
    id: "77",
    name: "Console",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/77.gltf",
    preview: "/cosmetic/preview/cape/77.webp",
    obtain: ["Computer Geek Crate"],
  },
  {
    id: "78",
    name: "Smart Phone",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/78.gltf",
    preview: "/cosmetic/preview/cape/78.webp",
    obtain: ["Computer Geek Crate"],
  },
  {
    id: "79",
    name: "Controller",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/79.gltf",
    preview: "/cosmetic/preview/cape/79.webp",
    obtain: ["Computer Geek Crate"],
  },
  {
    id: "80",
    name: "Switch",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/80.gltf",
    preview: "/cosmetic/preview/cape/80.webp",
    obtain: ["Computer Geek Crate"],
  },
  {
    id: "81",
    name: "Easter 2022 - Basket",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/81.gltf",
    preview: "/cosmetic/preview/cape/81.webp",
    obtain: ["2022 Easter Event Crate"],
  },
  {
    id: "82",
    name: "Easter 2022 - Bunny",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/82.gltf",
    preview: "/cosmetic/preview/cape/82.webp",
    obtain: ["2022 Easter Event Crate"],
  },
  {
    id: "83",
    name: "Easter 2022 - Moai",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/83.gltf",
    preview: "/cosmetic/preview/cape/83.webp",
    obtain: ["2022 Easter Event Crate"],
  },
  {
    id: "84",
    name: "Easter 2022 - Egg",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/84.gltf",
    preview: "/cosmetic/preview/cape/84.webp",
    obtain: ["2022 Easter Event Crate"],
  },
  {
    id: "85",
    name: "Easter 2022 - Basket 2",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/85.gltf",
    preview: "/cosmetic/preview/cape/85.webp",
    obtain: ["Unreleased"],
  },
  {
    id: "86",
    name: "Easter 2022 - Bunny 2",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/86.gltf",
    preview: "/cosmetic/preview/cape/86.webp",
    obtain: ["Unreleased"],
  },
  {
    id: "87",
    name: "Berry",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/87.gltf",
    preview: "/cosmetic/preview/cape/87.webp",
    obtain: ["Season 3 Zeqa Pass"],
  },
  {
    id: "88",
    name: "Kirby",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/88.gltf",
    preview: "/cosmetic/preview/cape/88.webp",
    obtain: ["Season 3 Zeqa Pass"],
  },
  {
    id: "89",
    name: "Rose",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/89.gltf",
    preview: "/cosmetic/preview/cape/89.webp",
    obtain: ["Season 3 Zeqa Pass"],
  },
  {
    id: "90",
    name: "Scroll",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/90.gltf",
    preview: "/cosmetic/preview/cape/90.webp",
    obtain: ["Season 3 Zeqa Pass"],
  },
  {
    id: "91",
    name: "Trophy",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/91.gltf",
    preview: "/cosmetic/preview/cape/91.webp",
    obtain: ["Season 3 Elo Leaderboard (#1-10) Rewards", "Store Lottery"],
  },
  {
    id: "92",
    name: "Earth Board",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/92.gltf",
    preview: "/cosmetic/preview/cape/92.webp",
    obtain: ["Unreleased"],
  },
  {
    id: "93",
    name: "SheeShult",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/93.gltf",
    preview: "/cosmetic/preview/cape/93.webp",
    obtain: ["Unreleased"],
  },
  {
    id: "94",
    name: "Pride - Agender",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/94.gltf",
    preview: "/cosmetic/preview/cape/94.webp",
    obtain: ["June 2022 Login Reward"],
  },
  {
    id: "95",
    name: "Pride - Ally",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/95.gltf",
    preview: "/cosmetic/preview/cape/95.webp",
    obtain: ["June 2022 Login Reward"],
  },
  {
    id: "96",
    name: "Pride - Bisexual",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/96.gltf",
    preview: "/cosmetic/preview/cape/96.webp",
    obtain: ["June 2022 Login Reward"],
  },
  {
    id: "97",
    name: "Pride - Fluid",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/97.gltf",
    preview: "/cosmetic/preview/cape/97.webp",
    obtain: ["June 2022 Login Reward"],
  },
  {
    id: "98",
    name: "Pride - Intersex",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/98.gltf",
    preview: "/cosmetic/preview/cape/98.webp",
    obtain: ["June 2022 Login Reward"],
  },
  {
    id: "99",
    name: "Pride - Lesbian",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/99.gltf",
    preview: "/cosmetic/preview/cape/99.webp",
    obtain: ["June 2022 Login Reward"],
  },
  {
    id: "100",
    name: "Pride - LGBTQ+",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/100.gltf",
    preview: "/cosmetic/preview/cape/100.webp",
    obtain: ["June 2022 Login Reward"],
  },
  {
    id: "101",
    name: "Pride - Non Binary",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/101.gltf",
    preview: "/cosmetic/preview/cape/101.webp",
    obtain: ["June 2022 Login Reward"],
  },
  {
    id: "102",
    name: "Pride - Pansexual",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/102.gltf",
    preview: "/cosmetic/preview/cape/102.webp",
    obtain: ["June 2022 Login Reward"],
  },
  {
    id: "103",
    name: "Pride - Transgender",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/103.gltf",
    preview: "/cosmetic/preview/cape/103.webp",
    obtain: ["June 2022 Login Reward"],
  },
  {
    id: "104",
    name: "Red Apple",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/104.gltf",
    preview: "/cosmetic/preview/cape/104.webp",
    obtain: ["Season 4 Zeqa Pass"],
  },
  {
    id: "105",
    name: "Pink Donut",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/105.gltf",
    preview: "/cosmetic/preview/cape/105.webp",
    obtain: ["Season 4 Zeqa Pass"],
  },
  {
    id: "106",
    name: "Soft Drink",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/106.gltf",
    preview: "/cosmetic/preview/cape/106.webp",
    obtain: ["Season 4 Zeqa Pass"],
  },
  {
    id: "107",
    name: "Hot Dog",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/107.gltf",
    preview: "/cosmetic/preview/cape/107.webp",
    obtain: ["Season 4 Zeqa Pass"],
  },
  {
    id: "108",
    name: "Friesy",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/108.gltf",
    preview: "/cosmetic/preview/cape/108.webp",
    obtain: ["Season 4 Zeqa Pass"],
  },
  {
    id: "109",
    name: "Muffin Avatar",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/109.gltf",
    preview: "/cosmetic/preview/cape/109.webp",
    obtain: ["Unreleased"],
  },
  {
    id: "110",
    name: "10K DISCORD CAPE",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/110.gltf",
    preview: "/cosmetic/preview/cape/110.webp",
    obtain: ["Season 4 Login Reward"],
  },
  {
    id: "111",
    name: "UFO",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/111.gltf",
    preview: "/cosmetic/preview/cape/111.webp",
    obtain: ["Season 4 Elo Leaderboard (#1-10) Rewards", "Store Lottery"],
  },
  {
    id: "112",
    name: "Peace",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/112.gltf",
    preview: "/cosmetic/preview/cape/112.webp",
    obtain: ["Season 4 Login Reward"],
  },
  {
    id: "113",
    name: "Alien",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/113.gltf",
    preview: "/cosmetic/preview/cape/113.webp",
    obtain: ["Season 6 Elo Leaderboard (#1-10) Rewards", "Store Lottery"],
  },
  {
    id: "114",
    name: "Amoung Us",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/114.gltf",
    preview: "/cosmetic/preview/cape/114.webp",
    obtain: ["Galactic Force Crate"],
  },
  {
    id: "115",
    name: "Earth",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/115.gltf",
    preview: "/cosmetic/preview/cape/115.webp",
    obtain: ["Galactic Force Crate"],
  },
  {
    id: "116",
    name: "Galaxy",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/116.gltf",
    preview: "/cosmetic/preview/cape/116.webp",
    obtain: ["Galactic Force Crate"],
  },
  {
    id: "117",
    name: "Jupiter",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/117.gltf",
    preview: "/cosmetic/preview/cape/117.webp",
    obtain: ["Galactic Force Crate"],
  },
  {
    id: "118",
    name: "Moob",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/118.gltf",
    preview: "/cosmetic/preview/cape/118.webp",
    obtain: ["Galactic Force Crate"],
  },
  {
    id: "119",
    name: "Robo",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/119.gltf",
    preview: "/cosmetic/preview/cape/119.webp",
    obtain: ["Galactic Force Crate"],
  },
  {
    id: "120",
    name: "Moon",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/120.gltf",
    preview: "/cosmetic/preview/cape/120.webp",
    obtain: ["Galactic Force Crate"],
  },
  {
    id: "121",
    name: "Rocket",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/121.gltf",
    preview: "/cosmetic/preview/cape/121.webp",
    obtain: ["Season 5 Elo Leaderboard (#1-10) Rewards", "Store Lottery"],
  },
  {
    id: "122",
    name: "Star Streak",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/122.gltf",
    preview: "/cosmetic/preview/cape/122.webp",
    obtain: ["Galactic Force Crate"],
  },
  {
    id: "123",
    name: "Citicx's Cape",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/123.gltf",
    preview: "/cosmetic/preview/cape/123.webp",
    obtain: ["Unreleased"],
  },
  {
    id: "124",
    name: "Foxzy",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/124.gltf",
    preview: "/cosmetic/preview/cape/124.webp",
    obtain: ["Season 5 Zeqa Pass"],
  },
  {
    id: "125",
    name: "Panda",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/125.gltf",
    preview: "/cosmetic/preview/cape/125.webp",
    obtain: ["Season 5 Zeqa Pass"],
  },
  {
    id: "126",
    name: "Penguin",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/126.gltf",
    preview: "/cosmetic/preview/cape/126.webp",
    obtain: ["Season 5 Zeqa Pass"],
  },
  {
    id: "127",
    name: "Rat",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/127.gltf",
    preview: "/cosmetic/preview/cape/127.webp",
    obtain: ["Season 5 Zeqa Pass"],
  },
  {
    id: "128",
    name: "Allay",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/128.gltf",
    preview: "/cosmetic/preview/cape/128.webp",
    obtain: ["Season 5 Zeqa Pass"],
  },
  {
    id: "129",
    name: "Halloween 2022 - Candy Corn",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/129.gltf",
    preview: "/cosmetic/preview/cape/129.webp",
    obtain: ["2022 Halloween Event Crate"],
  },
  {
    id: "130",
    name: "Halloween 2022 - Eye Ball",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/130.gltf",
    preview: "/cosmetic/preview/cape/130.webp",
    obtain: ["2022 Halloween Event Crate"],
  },
  {
    id: "131",
    name: "Halloween 2022 - Ghost",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/131.gltf",
    preview: "/cosmetic/preview/cape/131.webp",
    obtain: ["2022 Halloween Event Crate"],
  },
  {
    id: "132",
    name: "Halloween 2022 - Pumpkin",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/132.gltf",
    preview: "/cosmetic/preview/cape/132.webp",
    obtain: ["2022 Halloween Event Crate"],
  },
  {
    id: "133",
    name: "Blue Chr7st",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/133.gltf",
    preview: "/cosmetic/preview/cape/133.webp",
    obtain: ["Chr7st Collaboration"],
  },
  {
    id: "134",
    name: "Christmas 2022 - Chirstmas Tree",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/134.gltf",
    preview: "/cosmetic/preview/cape/134.webp",
    obtain: ["2022 Christmas Event Crate"],
  },
  {
    id: "135",
    name: "Christmas 2022 - Present",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/135.gltf",
    preview: "/cosmetic/preview/cape/135.webp",
    obtain: ["2022 Christmas Event Crate"],
  },
  {
    id: "136",
    name: "Christmas 2022 - Wreath",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/136.gltf",
    preview: "/cosmetic/preview/cape/136.webp",
    obtain: ["2022 Christmas Event Crate"],
  },
  {
    id: "137",
    name: "Christmas 2022 - Snowman",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/137.gltf",
    preview: "/cosmetic/preview/cape/137.webp",
    obtain: ["2022 Christmas Event Crate"],
  },
  {
    id: "138",
    name: "Air",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/138.gltf",
    preview: "/cosmetic/preview/cape/138.webp",
    obtain: ["Season 6 Zeqa Pass"],
  },
  {
    id: "139",
    name: "Earth",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/139.gltf",
    preview: "/cosmetic/preview/cape/139.webp",
    obtain: ["Season 6 Zeqa Pass"],
  },
  {
    id: "140",
    name: "Fire",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/140.gltf",
    preview: "/cosmetic/preview/cape/140.webp",
    obtain: ["Unreleased"],
  },
  {
    id: "141",
    name: "Gold",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/141.gltf",
    preview: "/cosmetic/preview/cape/141.webp",
    obtain: ["Season 6 Zeqa Pass"],
  },
  {
    id: "142",
    name: "Ice",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/142.gltf",
    preview: "/cosmetic/preview/cape/142.webp",
    obtain: ["Season 6 Zeqa Pass"],
  },
  {
    id: "143",
    name: "Lightning",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/143.gltf",
    preview: "/cosmetic/preview/cape/143.webp",
    obtain: ["Season 6 Zeqa Pass"],
  },
  {
    id: "144",
    name: "Silver",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/144.gltf",
    preview: "/cosmetic/preview/cape/144.webp",
    obtain: ["Season 6 Login Reward"],
  },
  {
    id: "145",
    name: "Water",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/145.gltf",
    preview: "/cosmetic/preview/cape/145.webp",
    obtain: ["Unreleased"],
  },
  {
    id: "146",
    name: "Zeqalotl",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/146.gltf",
    preview: "/cosmetic/preview/cape/146.webp",
    obtain: ["2022 X-mas Quest"],
  },
  {
    id: "147",
    name: "Red Beta",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/147.gltf",
    preview: "/cosmetic/preview/cape/147.webp",
    obtain: ["Zeqa's Dragonfly Beta"],
  },
  {
    id: "148",
    name: "Blue Beta",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/148.gltf",
    preview: "/cosmetic/preview/cape/148.webp",
    obtain: ["Zeqa's Dragonfly Beta"],
  },
  {
    id: "149",
    name: "Island",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/149.gltf",
    preview: "/cosmetic/preview/cape/149.webp",
    obtain: ["Season 7 Login Reward"],
  },
  {
    id: "150",
    name: "Pirate Flag",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/150.gltf",
    preview: "/cosmetic/preview/cape/150.webp",
    obtain: ["Season 7 Zeqa Pass"],
  },
  {
    id: "151",
    name: "Treasure Chest",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/151.gltf",
    preview: "/cosmetic/preview/cape/151.webp",
    obtain: ["Season 7 Zeqa Pass"],
  },
  {
    id: "152",
    name: "Treasure Map",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/152.gltf",
    preview: "/cosmetic/preview/cape/152.webp",
    obtain: ["Out Of The Sea Crate"],
  },
  {
    id: "153",
    name: "Wheel",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/153.gltf",
    preview: "/cosmetic/preview/cape/153.webp",
    obtain: ["Season 7 Zeqa Pass"],
  },
  {
    id: "154",
    name: "Anchor",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/154.gltf",
    preview: "/cosmetic/preview/cape/154.webp",
    obtain: ["Out Of The Sea Crate"],
  },
  {
    id: "155",
    name: "Crown",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/155.gltf",
    preview: "/cosmetic/preview/cape/155.webp",
    obtain: ["Season 7 Zeqa Pass"],
  },
  {
    id: "156",
    name: "Parrot Feather",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/156.gltf",
    preview: "/cosmetic/preview/cape/156.webp",
    obtain: ["Season 7 Zeqa Pass"],
  },
  {
    id: "157",
    name: "Skull",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/157.gltf",
    preview: "/cosmetic/preview/cape/157.webp",
    obtain: ["Out Of The Sea Crate"],
  },
  {
    id: "158",
    name: "Target",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/158.gltf",
    preview: "/cosmetic/preview/cape/158.webp",
    obtain: ["Out Of The Sea Crate"],
  },
  {
    id: "159",
    name: "Pharaoh's Cloak",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/159.gltf",
    preview: "/cosmetic/preview/cape/159.webp",
    obtain: ["Halloween Bundle 2023"],
  },
  {
    id: "160",
    name: "Jack-o'-lantern",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/160.gltf",
    preview: "/cosmetic/preview/cape/160.webp",
    obtain: ["Halloween Bundle 2023"],
  },
  {
    id: "161",
    name: "Gravestone",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/161.gltf",
    preview: "/cosmetic/preview/cape/161.webp",
    obtain: ["Halloween Bundle 2023"],
  },
  {
    id: "162",
    name: "Palestine",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/162.gltf",
    preview: "/cosmetic/preview/cape/162.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "163",
    name: "Argentina",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/163.gltf",
    preview: "/cosmetic/preview/cape/163.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "164",
    name: "Belgium",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/164.gltf",
    preview: "/cosmetic/preview/cape/164.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "165",
    name: "Brazil",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/165.gltf",
    preview: "/cosmetic/preview/cape/165.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "166",
    name: "Canada",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/166.gltf",
    preview: "/cosmetic/preview/cape/166.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "167",
    name: "China",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/167.gltf",
    preview: "/cosmetic/preview/cape/167.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "168",
    name: "United Arab Emirates",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/168.gltf",
    preview: "/cosmetic/preview/cape/168.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "169",
    name: "United Kingdom",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/169.gltf",
    preview: "/cosmetic/preview/cape/169.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "170",
    name: "France",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/170.gltf",
    preview: "/cosmetic/preview/cape/170.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "171",
    name: "Germany",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/171.gltf",
    preview: "/cosmetic/preview/cape/171.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "172",
    name: "South Africa",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/172.gltf",
    preview: "/cosmetic/preview/cape/172.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "173",
    name: "Italy",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/173.gltf",
    preview: "/cosmetic/preview/cape/173.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "174",
    name: "Japan",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/174.gltf",
    preview: "/cosmetic/preview/cape/174.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "175",
    name: "Mexico",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/175.gltf",
    preview: "/cosmetic/preview/cape/175.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "176",
    name: "Netherlands",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/176.gltf",
    preview: "/cosmetic/preview/cape/176.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "177",
    name: "Poland",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/177.gltf",
    preview: "/cosmetic/preview/cape/177.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "178",
    name: "Spain",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/178.gltf",
    preview: "/cosmetic/preview/cape/178.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "179",
    name: "Sweden",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/179.gltf",
    preview: "/cosmetic/preview/cape/179.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "180",
    name: "United States of America",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/180.gltf",
    preview: "/cosmetic/preview/cape/180.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "181",
    name: "Australia",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/181.gltf",
    preview: "/cosmetic/preview/cape/181.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "182",
    name: "New Zealand",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/182.gltf",
    preview: "/cosmetic/preview/cape/182.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "183",
    name: "Melon Cape",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/183.gltf",
    preview: "/cosmetic/preview/cape/183.webp",
    obtain: ["Scott"],
  },
  {
    id: "184",
    name: "Maple Leaf Stem",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/184.gltf",
    preview: "/cosmetic/preview/cape/184.webp",
    obtain: ["Autumn Bundle 2023"],
  },
  {
    id: "185",
    name: "Sunflower",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/185.gltf",
    preview: "/cosmetic/preview/cape/185.webp",
    obtain: ["Autumn Bundle 2023"],
  },
  {
    id: "186",
    name: "Ben 10",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/186.gltf",
    preview: "/cosmetic/preview/cape/186.webp",
    obtain: ["Cartoon Bundle 2023"],
  },
  {
    id: "187",
    name: "Bumblebee",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/187.gltf",
    preview: "/cosmetic/preview/cape/187.webp",
    obtain: ["Cartoon Bundle 2023"],
  },
  {
    id: "188",
    name: "Captain America",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/188.gltf",
    preview: "/cosmetic/preview/cape/188.webp",
    obtain: ["Cartoon Bundle 2023"],
  },
  {
    id: "189",
    name: "Groot",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/189.gltf",
    preview: "/cosmetic/preview/cape/189.webp",
    obtain: ["Cartoon Bundle 2023"],
  },
  {
    id: "190",
    name: "Iron Man",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/190.gltf",
    preview: "/cosmetic/preview/cape/190.webp",
    obtain: ["Cartoon Bundle 2023"],
  },
  {
    id: "191",
    name: "Minion",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/191.gltf",
    preview: "/cosmetic/preview/cape/191.webp",
    obtain: ["Cartoon Bundle 2023"],
  },
  {
    id: "192",
    name: "Spiderman",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/192.gltf",
    preview: "/cosmetic/preview/cape/192.webp",
    obtain: ["Cartoon Bundle 2023"],
  },
  {
    id: "193",
    name: "Toad",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/193.gltf",
    preview: "/cosmetic/preview/cape/193.webp",
    obtain: ["Cartoon Bundle 2023"],
  },
  {
    id: "194",
    name: "Tom",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/194.gltf",
    preview: "/cosmetic/preview/cape/194.webp",
    obtain: ["Cartoon Bundle 2023"],
  },
  {
    id: "195",
    name: "Winnie The Pooh",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/195.gltf",
    preview: "/cosmetic/preview/cape/195.webp",
    obtain: ["Cartoon Bundle 2023"],
  },
  {
    id: "196",
    name: "Arrow Heart",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/196.gltf",
    preview: "/cosmetic/preview/cape/196.webp",
    obtain: ["Cartoon Bundle 2023"],
  },
  {
    id: "197",
    name: "Hearts",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/197.gltf",
    preview: "/cosmetic/preview/cape/197.webp",
    obtain: ["Cartoon Bundle 2023"],
  },
  {
    id: "198",
    name: "RGB Heart",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/198.gltf",
    preview: "/cosmetic/preview/cape/198.webp",
    obtain: ["Cartoon Bundle 2023"],
  },
  {
    id: "199",
    name: "Rose Glass",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/199.gltf",
    preview: "/cosmetic/preview/cape/199.webp",
    obtain: ["Cartoon Bundle 2023"],
  },
  {
    id: "200",
    name: "Enchanters Cape",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/200.gltf",
    preview: "/cosmetic/preview/cape/200.webp",
    obtain: ["Season 8 Zeqa Pass"],
  },
  {
    id: "201",
    name: "Skull",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/201.gltf",
    preview: "/cosmetic/preview/cape/201.webp",
    obtain: ["Season 9 Login Reward"],
  },
  {
    id: "202",
    name: "Wizards Cape",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/202.gltf",
    preview: "/cosmetic/preview/cape/202.webp",
    obtain: ["Season 8 Zeqa Pass"],
  },
  {
    id: "203",
    name: "Christmas Star",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/203.gltf",
    preview: "/cosmetic/preview/cape/203.webp",
    obtain: ["Winter Bundle 2023"],
  },
  {
    id: "204",
    name: "Christmas Bauble",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/204.gltf",
    preview: "/cosmetic/preview/cape/204.webp",
    obtain: ["Winter Bundle 2023"],
  },
  {
    id: "205",
    name: "Reindeer",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/205.gltf",
    preview: "/cosmetic/preview/cape/205.webp",
    obtain: ["Winter Bundle 2023"],
  },
  {
    id: "206",
    name: "Fireplace",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/206.gltf",
    preview: "/cosmetic/preview/cape/206.webp",
    obtain: ["Winter Bundle 2023"],
  },
  {
    id: "207",
    name: "Chilly Charmer",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/207.gltf",
    preview: "/cosmetic/preview/cape/207.webp",
    obtain: ["Winter Bundle 2023"],
  },
  {
    id: "208",
    name: "Snowflake",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/208.gltf",
    preview: "/cosmetic/preview/cape/208.webp",
    obtain: ["Winter Bundle 2023"],
  },
  {
    id: "209",
    name: "ZeqMas",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/209.gltf",
    preview: "/cosmetic/preview/cape/209.webp",
    obtain: ["Winter Bundle 2023"],
  },
  {
    id: "210",
    name: "Bat",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/210.gltf",
    preview: "/cosmetic/preview/cape/210.webp",
    obtain: ["Halloween Login Reward 2024"],
  },
  {
    id: "211",
    name: "Zombie Hand",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/211.gltf",
    preview: "/cosmetic/preview/cape/211.webp",
    obtain: ["Halloween Login Reward 2024"],
  },
  {
    id: "212",
    name: "Golden Hearts",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/212.gltf",
    preview: "/cosmetic/preview/cape/212.webp",
    obtain: ["Valentines Crate 2024"],
  },
  {
    id: "213",
    name: "Heart King",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/213.gltf",
    preview: "/cosmetic/preview/cape/213.webp",
    obtain: ["Valentines Crate 2024"],
  },
  {
    id: "214",
    name: "Red Heart",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/214.gltf",
    preview: "/cosmetic/preview/cape/214.webp",
    obtain: ["Valentines Crate 2024"],
  },
  {
    id: "215",
    name: "Pink Heart",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/215.gltf",
    preview: "/cosmetic/preview/cape/215.webp",
    obtain: ["Valentines Crate 2024"],
  },
  {
    id: "216",
    name: "Candy",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/216.gltf",
    preview: "/cosmetic/preview/cape/216.webp",
    obtain: ["Valentines Crate 2024"],
  },
  {
    id: "217",
    name: "Heart",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/217.gltf",
    preview: "/cosmetic/preview/cape/217.webp",
    obtain: ["Valentines Crate 2024"],
  },
  {
    id: "218",
    name: "Chocolate",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/218.gltf",
    preview: "/cosmetic/preview/cape/218.webp",
    obtain: ["Valentines Crate 2024"],
  },
  {
    id: "219",
    name: "Blossom",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/219.gltf",
    preview: "/cosmetic/preview/cape/219.webp",
    obtain: ["Valentines Crate 2024"],
  },
  {
    id: "220",
    name: "White Chocolate",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/220.gltf",
    preview: "/cosmetic/preview/cape/220.webp",
    obtain: ["Discord 20k Celebration"],
  },
  {
    id: "221",
    name: "Dark Chocolate",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/221.gltf",
    preview: "/cosmetic/preview/cape/221.webp",
    obtain: ["Discord 20k Celebration"],
  },
  {
    id: "222",
    name: "Music Note",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/222.gltf",
    preview: "/cosmetic/preview/cape/222.webp",
    obtain: ["Discord 20k Celebration"],
  },
  {
    id: "223",
    name: "Red Balloon",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/223.gltf",
    preview: "/cosmetic/preview/cape/223.webp",
    obtain: ["Discord 20k Celebration"],
  },
  {
    id: "224",
    name: "Green Balloon",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/224.gltf",
    preview: "/cosmetic/preview/cape/224.webp",
    obtain: ["Discord 20k Celebration"],
  },
  {
    id: "225",
    name: "Blue Balloon",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/225.gltf",
    preview: "/cosmetic/preview/cape/225.webp",
    obtain: ["Discord 20k Celebration"],
  },
  {
    id: "226",
    name: "Purple Balloon",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/226.gltf",
    preview: "/cosmetic/preview/cape/226.webp",
    obtain: ["Discord 20k Celebration"],
  },
  {
    id: "227",
    name: "Glimmer",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/227.gltf",
    preview: "/cosmetic/preview/cape/227.webp",
    obtain: ["Discord 20k Celebration"],
  },
  {
    id: "228",
    name: "Clown Cape",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/228.gltf",
    preview: "/cosmetic/preview/cape/228.webp",
    obtain: ["Discord 20k Celebration"],
  },
  {
    id: "229",
    name: "Pinata",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/229.gltf",
    preview: "/cosmetic/preview/cape/229.webp",
    obtain: ["Discord 20k Celebration"],
  },
  {
    id: "230",
    name: "Donkey Tail",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/230.gltf",
    preview: "/cosmetic/preview/cape/230.webp",
    obtain: ["Discord 20k Celebration"],
  },
  {
    id: "231",
    name: "Root Beer",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/231.gltf",
    preview: "/cosmetic/preview/cape/231.webp",
    obtain: ["Discord 20k Celebration"],
  },
  {
    id: "232",
    name: "ButterBeer",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/232.gltf",
    preview: "/cosmetic/preview/cape/232.webp",
    obtain: ["Discord 20k Celebration"],
  },
  {
    id: "233",
    name: "Chocolate Cake",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/233.gltf",
    preview: "/cosmetic/preview/cape/233.webp",
    obtain: ["Discord 20k Celebration"],
  },
  {
    id: "234",
    name: "Cake",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/234.gltf",
    preview: "/cosmetic/preview/cape/234.webp",
    obtain: ["Discord 20k Celebration"],
  },
  {
    id: "235",
    name: "Birthday Cake",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/235.gltf",
    preview: "/cosmetic/preview/cape/235.webp",
    obtain: ["Discord 20k Celebration"],
  },
  {
    id: "236",
    name: "Easter Egg",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/236.gltf",
    preview: "/cosmetic/preview/cape/236.webp",
    obtain: ["Easter Bundle 2024"],
  },
  {
    id: "237",
    name: "Terry The Chick",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/237.gltf",
    preview: "/cosmetic/preview/cape/237.webp",
    obtain: ["Easter Bundle 2024"],
  },
  {
    id: "238",
    name: "Fresh Start",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/238.gltf",
    preview: "/cosmetic/preview/cape/238.webp",
    obtain: ["Easter Bundle 2024"],
  },
  {
    id: "239",
    name: "Golden Egg",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/239.gltf",
    preview: "/cosmetic/preview/cape/239.webp",
    obtain: ["Easter Bundle 2024"],
  },
  {
    id: "240",
    name: "Butterfly",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/240.gltf",
    preview: "/cosmetic/preview/cape/240.webp",
    obtain: ["Easter Bundle 2024"],
  },
  {
    id: "241",
    name: "Carrot",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/241.gltf",
    preview: "/cosmetic/preview/cape/241.webp",
    obtain: ["Easter Bundle 2024"],
  },
  {
    id: "242",
    name: "Tulips",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/242.gltf",
    preview: "/cosmetic/preview/cape/242.webp",
    obtain: ["Easter Bundle 2024"],
  },
  {
    id: "243",
    name: "Chicken Coop",
    type: "cape",
    rarity: "exotic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/243.gltf",
    preview: "/cosmetic/preview/cape/243.webp",
    obtain: ["Easter Bundle 2024"],
  },
  {
    id: "244",
    name: "Clown",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/244.gltf",
    preview: "/cosmetic/preview/cape/244.webp",
    obtain: ["NPC Behaviour Crate"],
  },
  {
    id: "245",
    name: "Nerd",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/245.gltf",
    preview: "/cosmetic/preview/cape/245.webp",
    obtain: ["NPC Behaviour Crate"],
  },
  {
    id: "246",
    name: "Noob Smile",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/246.gltf",
    preview: "/cosmetic/preview/cape/246.webp",
    obtain: ["NPC Behaviour Crate"],
  },
  {
    id: "247",
    name: "Disguise",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/247.gltf",
    preview: "/cosmetic/preview/cape/247.webp",
    obtain: ["NPC Behaviour Crate"],
  },
  {
    id: "248",
    name: "Mike Wazoski",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/248.gltf",
    preview: "/cosmetic/preview/cape/248.webp",
    obtain: ["NPC Behaviour Crate"],
  },
  {
    id: "249",
    name: "CODM Gun",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/249.gltf",
    preview: "/cosmetic/preview/cape/249.webp",
    obtain: ["Mobile Gaming Crate"],
  },
  {
    id: "250",
    name: "Fortnite Piñata",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/250.gltf",
    preview: "/cosmetic/preview/cape/250.webp",
    obtain: ["Mobile Gaming Crate"],
  },
  {
    id: "251",
    name: "Tetris",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/251.gltf",
    preview: "/cosmetic/preview/cape/251.webp",
    obtain: ["Mobile Gaming Crate"],
  },
  {
    id: "252",
    name: "Angry Bird",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/252.gltf",
    preview: "/cosmetic/preview/cape/252.webp",
    obtain: ["Mobile Gaming Crate"],
  },
  {
    id: "253",
    name: "Terraria",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/253.gltf",
    preview: "/cosmetic/preview/cape/253.webp",
    obtain: ["Mobile Gaming Crate"],
  },
  {
    id: "254",
    name: "Retro Bowl",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/254.gltf",
    preview: "/cosmetic/preview/cape/254.webp",
    obtain: ["Mobile Gaming Crate"],
  },
  {
    id: "255",
    name: "Hoverboard",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/255.gltf",
    preview: "/cosmetic/preview/cape/255.webp",
    obtain: ["Mobile Gaming Crate"],
  },
  {
    id: "256",
    name: "Bad Piggie",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/256.gltf",
    preview: "/cosmetic/preview/cape/256.webp",
    obtain: ["Mobile Gaming Crate"],
  },
  {
    id: "257",
    name: "Pokeball",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/257.gltf",
    preview: "/cosmetic/preview/cape/257.webp",
    obtain: ["Mobile Gaming Crate"],
  },
  {
    id: "258",
    name: "Fruit Ninja",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/258.gltf",
    preview: "/cosmetic/preview/cape/258.webp",
    obtain: ["Mobile Gaming Crate"],
  },
  {
    id: "259",
    name: "Pipe",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/259.gltf",
    preview: "/cosmetic/preview/cape/259.webp",
    obtain: ["Mobile Gaming Crate"],
  },
  {
    id: "260",
    name: "Slitherio",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/260.gltf",
    preview: "/cosmetic/preview/cape/260.webp",
    obtain: ["Mobile Gaming Crate"],
  },
  {
    id: "261",
    name: "Inky",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/261.gltf",
    preview: "/cosmetic/preview/cape/261.webp",
    obtain: ["Mobile Gaming Crate"],
  },
  {
    id: "262",
    name: "Pinky",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/262.gltf",
    preview: "/cosmetic/preview/cape/262.webp",
    obtain: ["Mobile Gaming Crate"],
  },
  {
    id: "263",
    name: "Blinky",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/263.gltf",
    preview: "/cosmetic/preview/cape/263.webp",
    obtain: ["Mobile Gaming Crate"],
  },
  {
    id: "264",
    name: "Clyde",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/264.gltf",
    preview: "/cosmetic/preview/cape/264.webp",
    obtain: ["Mobile Gaming Crate"],
  },
  {
    id: "265",
    name: "Pikachu",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/265.gltf",
    preview: "/cosmetic/preview/cape/265.webp",
    obtain: ["Mobile Gaming Crate"],
  },
  {
    id: "266",
    name: "Geometry Dash",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/266.gltf",
    preview: "/cosmetic/preview/cape/266.webp",
    obtain: ["Mobile Gaming Crate"],
  },
  {
    id: "267",
    name: "Talking Tom",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/267.gltf",
    preview: "/cosmetic/preview/cape/267.webp",
    obtain: ["Mobile Gaming Crate"],
  },
  {
    id: "268",
    name: "Roblox",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/268.gltf",
    preview: "/cosmetic/preview/cape/268.webp",
    obtain: ["Mobile Gaming Crate"],
  },
  {
    id: "269",
    name: "Candy Corn",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/269.gltf",
    preview: "/cosmetic/preview/cape/269.webp",
    obtain: ["Candyland Crate"],
  },
  {
    id: "270",
    name: "Gummy Bear",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/270.gltf",
    preview: "/cosmetic/preview/cape/270.webp",
    obtain: ["Candyland Crate"],
  },
  {
    id: "271",
    name: "Ring Pop",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/271.gltf",
    preview: "/cosmetic/preview/cape/271.webp",
    obtain: ["Candyland Crate"],
  },
  {
    id: "272",
    name: "Candy Cane",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/272.gltf",
    preview: "/cosmetic/preview/cape/272.webp",
    obtain: ["Candyland Crate"],
  },
  {
    id: "273",
    name: "Cotton Candy",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/273.gltf",
    preview: "/cosmetic/preview/cape/273.webp",
    obtain: ["Candyland Crate"],
  },
  {
    id: "274",
    name: "Lollipop",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/274.gltf",
    preview: "/cosmetic/preview/cape/274.webp",
    obtain: ["Candyland Crate"],
  },
  {
    id: "275",
    name: "Hot Air Balloon",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/275.gltf",
    preview: "/cosmetic/preview/cape/275.webp",
    obtain: ["Tropical Crate"],
  },
  {
    id: "276",
    name: "Popsicle",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/276.gltf",
    preview: "/cosmetic/preview/cape/276.webp",
    obtain: ["Tropical Crate"],
  },
  {
    id: "277",
    name: "Tent",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/277.gltf",
    preview: "/cosmetic/preview/cape/277.webp",
    obtain: ["Tropical Crate"],
  },
  {
    id: "278",
    name: "Ocean Waves",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/278.gltf",
    preview: "/cosmetic/preview/cape/278.webp",
    obtain: ["Tropical Crate"],
  },
  {
    id: "279",
    name: "Sunset",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/279.gltf",
    preview: "/cosmetic/preview/cape/279.webp",
    obtain: ["Tropical Crate"],
  },
  {
    id: "280",
    name: "Bird Eye",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/280.gltf",
    preview: "/cosmetic/preview/cape/280.webp",
    obtain: ["Bird Bonanza Crate"],
  },
  {
    id: "281",
    name: "Shadow Bird",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/281.gltf",
    preview: "/cosmetic/preview/cape/281.webp",
    obtain: ["Bird Bonanza Crate"],
  },
  {
    id: "282",
    name: "Sunrise Bird",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/282.gltf",
    preview: "/cosmetic/preview/cape/282.webp",
    obtain: ["Bird Bonanza Crate"],
  },
  {
    id: "283",
    name: "Eagle",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/283.gltf",
    preview: "/cosmetic/preview/cape/283.webp",
    obtain: ["Bird Bonanza Crate"],
  },
  {
    id: "284",
    name: "Rooster",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/284.gltf",
    preview: "/cosmetic/preview/cape/284.webp",
    obtain: ["Bird Bonanza Crate"],
  },
  {
    id: "285",
    name: "Fake Parrot",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/285.gltf",
    preview: "/cosmetic/preview/cape/285.webp",
    obtain: ["Bird Bonanza Crate"],
  },
  {
    id: "286",
    name: "Glorious Cape",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/286.gltf",
    preview: "/cosmetic/preview/cape/286.webp",
    obtain: ["Elite Rank"],
  },
  {
    id: "287",
    name: "Black Glorious Cape",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/287.gltf",
    preview: "/cosmetic/preview/cape/287.webp",
    obtain: ["Elite Rank"],
  },
  {
    id: "288",
    name: "Red Glorious Cape",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/288.gltf",
    preview: "/cosmetic/preview/cape/288.webp",
    obtain: ["Elite Rank"],
  },
  {
    id: "289",
    name: "Orange Glorious Cape",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/289.gltf",
    preview: "/cosmetic/preview/cape/289.webp",
    obtain: ["Elite Rank"],
  },
  {
    id: "290",
    name: "Yellow Glorious Cape",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/290.gltf",
    preview: "/cosmetic/preview/cape/290.webp",
    obtain: ["Elite Rank"],
  },
  {
    id: "291",
    name: "Lime Glorious Cape",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/291.gltf",
    preview: "/cosmetic/preview/cape/291.webp",
    obtain: ["Elite Rank"],
  },
  {
    id: "292",
    name: "Green Glorious Cape",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/292.gltf",
    preview: "/cosmetic/preview/cape/292.webp",
    obtain: ["Elite Rank"],
  },
  {
    id: "293",
    name: "Aqua Glorious Cape",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/293.gltf",
    preview: "/cosmetic/preview/cape/293.webp",
    obtain: ["Elite Rank"],
  },
  {
    id: "294",
    name: "Blue Glorious Cape",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/294.gltf",
    preview: "/cosmetic/preview/cape/294.webp",
    obtain: ["Elite Rank"],
  },
  {
    id: "295",
    name: "Pink Glorious Cape",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/295.gltf",
    preview: "/cosmetic/preview/cape/295.webp",
    obtain: ["Elite Rank"],
  },
  {
    id: "296",
    name: "Purple Glorious Cape",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/296.gltf",
    preview: "/cosmetic/preview/cape/296.webp",
    obtain: ["Elite Rank"],
  },
  {
    id: "297",
    name: "Gray Glorious Cape",
    type: "cape",
    rarity: "limited",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/297.gltf",
    preview: "/cosmetic/preview/cape/297.webp",
    obtain: ["Elite Rank"],
  },
  {
    id: "298",
    name: "Archer Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/298.gltf",
    preview: "/cosmetic/preview/cape/298.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "299",
    name: "Battlerush Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/299.gltf",
    preview: "/cosmetic/preview/cape/299.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "300",
    name: "BedFight Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/300.gltf",
    preview: "/cosmetic/preview/cape/300.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "301",
    name: "Boxing Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/301.gltf",
    preview: "/cosmetic/preview/cape/301.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "302",
    name: "Bridge Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/302.gltf",
    preview: "/cosmetic/preview/cape/302.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "303",
    name: "BuildUHC Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/303.gltf",
    preview: "/cosmetic/preview/cape/303.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "304",
    name: "CaveUHC Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/304.gltf",
    preview: "/cosmetic/preview/cape/304.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "305",
    name: "Classic Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/305.gltf",
    preview: "/cosmetic/preview/cape/305.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "306",
    name: "Combo Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/306.gltf",
    preview: "/cosmetic/preview/cape/306.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "307",
    name: "Debuff Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/307.gltf",
    preview: "/cosmetic/preview/cape/307.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "308",
    name: "FinalUHC Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/308.gltf",
    preview: "/cosmetic/preview/cape/308.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "309",
    name: "FireballFight Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/309.gltf",
    preview: "/cosmetic/preview/cape/309.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "310",
    name: "Fist Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/310.gltf",
    preview: "/cosmetic/preview/cape/310.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "311",
    name: "Gapple Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/311.gltf",
    preview: "/cosmetic/preview/cape/311.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "312",
    name: "MLGRush Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/312.gltf",
    preview: "/cosmetic/preview/cape/312.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "313",
    name: "NetherUHC Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/313.gltf",
    preview: "/cosmetic/preview/cape/313.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "314",
    name: "NoDebuff Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/314.gltf",
    preview: "/cosmetic/preview/cape/314.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "315",
    name: "Pearlfight Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/315.gltf",
    preview: "/cosmetic/preview/cape/315.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "316",
    name: "SG Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/316.gltf",
    preview: "/cosmetic/preview/cape/316.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "317",
    name: "Skywars Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/317.gltf",
    preview: "/cosmetic/preview/cape/317.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "318",
    name: "Snowball Sumo Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/318.gltf",
    preview: "/cosmetic/preview/cape/318.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "319",
    name: "Soup Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/319.gltf",
    preview: "/cosmetic/preview/cape/319.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "320",
    name: "Spleef Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/320.gltf",
    preview: "/cosmetic/preview/cape/320.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "321",
    name: "StickFight Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/321.gltf",
    preview: "/cosmetic/preview/cape/321.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "322",
    name: "Sumo Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/322.gltf",
    preview: "/cosmetic/preview/cape/322.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "323",
    name: "Wrath Champion",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/323.gltf",
    preview: "/cosmetic/preview/cape/323.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "324",
    name: "Archer Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/324.gltf",
    preview: "/cosmetic/preview/cape/324.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "325",
    name: "Battlerush Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/325.gltf",
    preview: "/cosmetic/preview/cape/325.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "326",
    name: "BedFight Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/326.gltf",
    preview: "/cosmetic/preview/cape/326.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "327",
    name: "Boxing Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/327.gltf",
    preview: "/cosmetic/preview/cape/327.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "328",
    name: "Bridge Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/328.gltf",
    preview: "/cosmetic/preview/cape/328.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "329",
    name: "BuildUHC Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/329.gltf",
    preview: "/cosmetic/preview/cape/329.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "330",
    name: "CaveUHC Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/330.gltf",
    preview: "/cosmetic/preview/cape/330.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "331",
    name: "Classic Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/331.gltf",
    preview: "/cosmetic/preview/cape/331.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "332",
    name: "Combo Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/332.gltf",
    preview: "/cosmetic/preview/cape/332.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "333",
    name: "Debuff Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/333.gltf",
    preview: "/cosmetic/preview/cape/333.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "334",
    name: "FinalUHC Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/334.gltf",
    preview: "/cosmetic/preview/cape/334.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "335",
    name: "FireballFight Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/335.gltf",
    preview: "/cosmetic/preview/cape/335.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "336",
    name: "Fist Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/336.gltf",
    preview: "/cosmetic/preview/cape/336.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "337",
    name: "Gapple Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/337.gltf",
    preview: "/cosmetic/preview/cape/337.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "338",
    name: "MLGRush Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/338.gltf",
    preview: "/cosmetic/preview/cape/338.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "339",
    name: "NetherUHC Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/339.gltf",
    preview: "/cosmetic/preview/cape/339.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "340",
    name: "NoDebuff Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/340.gltf",
    preview: "/cosmetic/preview/cape/340.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "341",
    name: "Pearlfight Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/341.gltf",
    preview: "/cosmetic/preview/cape/341.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "342",
    name: "SG Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/342.gltf",
    preview: "/cosmetic/preview/cape/342.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "343",
    name: "Skywars Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/343.gltf",
    preview: "/cosmetic/preview/cape/343.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "344",
    name: "Snowball Sumo Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/344.gltf",
    preview: "/cosmetic/preview/cape/344.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "345",
    name: "Soup Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/345.gltf",
    preview: "/cosmetic/preview/cape/345.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "346",
    name: "Spleef Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/346.gltf",
    preview: "/cosmetic/preview/cape/346.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "347",
    name: "StickFight Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/347.gltf",
    preview: "/cosmetic/preview/cape/347.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "348",
    name: "Sumo Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/348.gltf",
    preview: "/cosmetic/preview/cape/348.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "349",
    name: "Wrath Warrior",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/349.gltf",
    preview: "/cosmetic/preview/cape/349.webp",
    obtain: ["Season 7 Elo Rewards"],
  },
  {
    id: "350",
    name: "Purple Beta",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/350.gltf",
    preview: "/cosmetic/preview/cape/350.webp",
    obtain: ["Season 8 Beta Reward"],
  },
  {
    id: "351",
    name: "Discord 30K Cape",
    type: "cape",
    rarity: "limited",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/351.gltf",
    preview: "/cosmetic/preview/cape/351.webp",
    obtain: ["Discord 30k Celebration"],
  },
  {
    id: "352",
    name: "Horsey",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/352.gltf",
    preview: "/cosmetic/preview/cape/352.webp",
    obtain: ["Season 9 Login Reward"],
  },
  {
    id: "353",
    name: "Dragon Scales",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/353.gltf",
    preview: "/cosmetic/preview/cape/353.webp",
    obtain: ["Season 9 Login Reward"],
  },
  {
    id: "354",
    name: "Gremlin",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/354.gltf",
    preview: "/cosmetic/preview/cape/354.webp",
    obtain: ["Season 9 Login Reward"],
  },
  {
    id: "355",
    name: "Ancient Creeper",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/355.gltf",
    preview: "/cosmetic/preview/cape/355.webp",
    obtain: ["Season 9 Zeqa Pass"],
  },
  {
    id: "356",
    name: "Versus",
    type: "cape",
    rarity: "rare",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/356.gltf",
    preview: "/cosmetic/preview/cape/356.webp",
    obtain: ["Season 9 Zeqa Pass"],
  },
  {
    id: "357",
    name: "Dragon",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/357.gltf",
    preview: "/cosmetic/preview/cape/357.webp",
    obtain: ["Season 9 Zeqa Pass"],
  },
  {
    id: "358",
    name: "Mushling Cape",
    type: "cape",
    rarity: "epic",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/358.gltf",
    preview: "/cosmetic/preview/cape/358.webp",
    obtain: ["Season 9 Zeqa Pass"],
  },
  {
    id: "359",
    name: "Phoenix Feather",
    type: "cape",
    rarity: "legendary",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/359.gltf",
    preview: "/cosmetic/preview/cape/359.webp",
    obtain: ["Season 9 Zeqa Pass"],
  },
  {
    id: "360",
    name: "Royal",
    type: "cape",
    rarity: "common",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/360.gltf",
    preview: "/cosmetic/preview/cape/360.webp",
    obtain: ["Season 9 Zeqa Pass"],
  },

  {
    id: "PC1",
    name: "Gengar Cape",
    type: "cape",
    rarity: "partner",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/PC1.gltf",
    preview: "/cosmetic/preview/cape/PC1.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "PC2",
    name: "Tub's Cape",
    type: "cape",
    rarity: "partner",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/PC2.gltf",
    preview: "/cosmetic/preview/cape/PC2.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "PC3",
    name: "GM19's Cape",
    type: "cape",
    rarity: "partner",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/PC3.gltf",
    preview: "/cosmetic/preview/cape/PC3.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "PC4",
    name: "Avery's Lunar Cape",
    type: "cape",
    rarity: "partner",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/PC4.gltf",
    preview: "/cosmetic/preview/cape/PC4.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  /*{
    id: "PC5",
    name: "Icy's Cape",
    type: "cape",
    rarity: "partner",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/PC5.gltf",
    preview: "/cosmetic/preview/cape/PC5.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },*/
  {
    id: "PC6",
    name: "Fenwos' Cape",
    type: "cape",
    rarity: "partner",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/PC6.gltf",
    preview: "/cosmetic/preview/cape/PC6.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "PC7",
    name: "DanyPlayz' Cape",
    type: "cape",
    rarity: "partner",
    isTradable: true,
    content: null,
    model: "/cosmetic/model/cape/PC7.gltf",
    preview: "/cosmetic/preview/cape/PC7.webp",
    obtain: ["Purchasable on store.zeqa.net"],
  },
  {
    id: "870",
    name: "Onix Client Cape",
    type: "cape",
    rarity: "partner",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/cape/870.gltf",
    preview: "/cosmetic/preview/cape/870.webp",
    obtain: ["Use of Onix Client on Zeqa"],
  },
];
